import { FormControlOptions } from '@miq/catalog';

export const ContactFormConfig: { [key: string]: FormControlOptions<any> } = Object.freeze({
  phone: {
    type: 'array',
    name: 'phone',
    controlsConfig: {
      id: [null],
      _mode: [null],
      phone_type_desc: [null],
      local_area_code: [null],
      phone_number: [null],
    },
  },
  digital: {
    type: 'array',
    name: 'digital',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  company_role_addresses: {
    type: 'array',
    name: 'company_role_addresses',
    controlsConfig: {
      id: [null],
      company_id: [null],
      role_desc: [null],
      primary_f: [null],
      expiry_date: [null],
    },
    children: {
      location: {
        name: 'location',
        type: 'group',
        controlsConfig: {
          location_id: [null],
        },
      },
      colloquial: {
        name: 'colloquial',
        type: 'array',
        controlsConfig: {
          id: [null],
          language_desc: [],
          country_code_desc: [],
        },
      },
    },
  },
  colloquial: {
    name: 'colloquial',
    type: 'array',
    controlsConfig: {
      id: [null],
      _mode: [null],
      country_code_desc: [null],
      language_desc: [null],
    },
  },
});
